// extracted by mini-css-extract-plugin
export var legendIndicator = "_b4-1";
export var legendRight = "_b4-0";